import { Button } from '@/src/common/components/Button'
import { Dialog } from 'tamagui'
import type { ThankYouProps } from './types'
import { SurveysE2E } from '../../e2e'

export const ThankYou = ({ onDismiss }: ThankYouProps) => (
  <>
    <Dialog.Title key="title" text="center" fontSize="$6" lineHeight="$10">
      Thank you for your feedback!
    </Dialog.Title>
    <Button
      title="Dismiss"
      onPress={onDismiss}
      style={{ marginTop: 16 }}
      testID={SurveysE2E.Ids.Press.ThankYouDismiss}
    />
  </>
)
